import { buildEndPoint } from '@mairistem/tools';

import baseUrl from './base';

export const getPayeurs = ({ page, perPage } = { page: 1, perPage: 15 }) =>
  `${baseUrl}/payeurs?page=${page}${perPage ? `&perPage=${perPage}` : ''}`;
export const searchPayeurs = (
  { query, perPage } = {
    query: '',
    perPage: 10,
  },
) =>
  buildEndPoint(`${baseUrl}/payeurs/search`, {
    q: query,
    perPage: perPage || 10,
  });
export const getPayeurFactures = ({ identifiantPayeur, page = 1 }) =>
  `${baseUrl}/payeurs/${identifiantPayeur}/factures?page=${page}`;
